import React, { useState } from "react";
import Select from "../../components/form/Select";
import ModelAdmin from "./modeladmin";
import TextureAdmin from "./textureadmin";

interface Viewer3DPanelProps {
  className?: string;
}

const Viewer3DPanel: React.FC<Viewer3DPanelProps> = ({ className = "" }) => {
  const [selectedView, setSelectedView] = useState<string>("texture");

  const viewOptions = [
    { value: "texture", label: "Texture" },
    // { value: "color", label: "Color" },
    { value: "models", label: "Models" }
  ];

  const handleViewChange = (value: string) => {
    setSelectedView(value);
  };

  const renderContent = () => {
    switch (selectedView) {
      case "texture":
        return (
          <div className="p-6 w-full overflow-hidden" style={{maxWidth: '100%'}}>
            <TextureAdmin />
          </div>
        );
      
      case "color":
        return (
          <div className="p-6">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
              Color Management
            </h3>
            <div className="bg-gray-50 dark:bg-gray-700 rounded-lg p-8 text-center">
              <p className="text-gray-600 dark:text-gray-400">
                Color management content will be displayed here
              </p>
            </div>
          </div>
        );
      
       case "models":
         return (
         <div className="p-6 w-full overflow-hidden" style={{maxWidth: '100%'}}>
           <ModelAdmin />
         </div>
         );
      
      default:
        return null;
    }
  };

  return (
    <div className={`bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 ${className}`}>
      {/* Header with Dropdown */}
      <div className="flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-700">
        <div>
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
            3D Viewer Panel
          </h2>
          <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
            Manage textures, colors, and models
          </p>
        </div>
        
        <div className="flex items-center gap-3">
          <label className="text-sm font-medium text-gray-700 dark:text-gray-300">
            View:
          </label>
          <Select
            options={viewOptions}
            placeholder="Select view"
            onChange={handleViewChange}
            defaultValue={selectedView}
            className="w-32"
          />
        </div>
      </div>

      {/* Content Area */}
      <div className="min-h-[600px]">
        {renderContent()}
      </div>
    </div>
  );
};

export default Viewer3DPanel;
